<template>
    <div>
        <!-- <div>转为正式产品</div> -->
        <vForm :label-width="80" class="margin-15 clearfix" ref="editform">
            <vFormItem label="项目" :rules="required" prop="lineId">
                <Select v-model="lineId" clearable>
                    <Option v-for="(item,index) in getNewProductList" :value="item.value" :key="index">{{item.label}}</Option>
                </Select>
                <span class="color-error">找不到项目请找相关人员先添加</span>
            </vFormItem>
            <vFormItem label="ERPSKU" :rules="required" prop="ERPSKU">
                <vButton theme="primary" @click="addErpsku">添加</vButton>
                <div v-for="(item,index) in erpskuList" :key="index" class="margin-top-10">
                    <Input class="width-40per margin-right-20" v-model="item.erpsku" placeholder="字母，数字，下划线，横杠，3-50字符"></Input>
                    备注：<Input class="width-40per" v-model="item.remark" placeholder="备注"></Input>
                </div>
            </vFormItem>
        </vForm>
        <div class="text-right">
            <vButton theme="primary" @click="submit">保存</vButton>
            <vButton class="margin-left-5" @click="close">取消</vButton>
        </div>
    </div>
</template>

<script>
import { mapState,mapGetters } from "vuex";
import { HttpSaveProductDev } from "@/service/proddevelop";

export default {
    props:['entrydata','lineid'],
    data(){
        return {
            required: [{
                required: true,
                message: "该信息不能为空,请填写"
            }],
            lineId:this.lineid || 0,
            erpskuList:[
                { erpsku:'', remark:''},
                { erpsku:'', remark:''},
                { erpsku:'', remark:''},
            ],
        }
    },
    computed:{
        ...mapGetters('diction',['getNewProductList']),
    },
    methods:{
        addErpsku(){
            let data = {
                erpsku:'',
                remark:'',
            } ;
            this.erpskuList.push(data)
        },
        async submit(){
            console.log(this.erpskuList,this.lineId)
            if(this.lineId == 0 || this.lineId == undefined || this.erpskuList.length<1 || this.erpskuList[0].erpsku == ''){
                this.$VMessage.error('请填写必填项');
                return;
            }

            var titleLine = /^([A-Za-z0-9-_./#]{3,50})$/;

            let flag = false
            this.erpskuList.map(item=>{
                if(item.erpsku){
                    if(titleLine.test(item.erpsku)===false){
                        flag = true;
                    }
                }
            })

            if(flag){
                this.$VMessage.error('ERPSKU输入不符合规范');
                return;
            }

            let array = [];
            this.erpskuList.map(item=>{
                if(item.erpsku){
                    array.push({erpSku:item.erpsku,remark:item.remark})
                }
            })
            HttpSaveProductDev({
                preselectionId:this.entrydata,
                orgId:global.SYSID,
                lineId:this.lineId,
                skuList:array,
            }).then(res=>{
                this.$VMessage.success(res.message);
                this.close()
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        close(){
            this.$emit('on-close')
        }
    }
}
</script>
